import styled from '@emotion/styled'
import bp from 'shared/constants/breakpoints'

export const Wrapper = styled.div`
  display: grid;
  grid-row-gap: 2em;
  max-width: 850px;

  & > button {
    width: max-content;
  }

  h3,
  h4 {
    margin-bottom: 0.5em;
  }

  @media screen and (max-width: ${bp.xlarge}) {
    padding: 0 1em;
  }

  @media screen and (max-width: ${bp.small}) {
    margin-top: 0;
    padding: 0;

    button {
      margin-top: 0;
    }
  }
`

export const Section = styled.div`
  margin-bottom: 1.5em;
`

export const Break = styled.br``
